/**
 * Generates a unique error ID for form components when needed for accessibility.
 *
 * @param componentPrefix - The component prefix to use in the ID (e.g., 'text-area', 'text-input')
 * @param hasError - Whether the component has an error
 * @param existingAriaDescribedBy - Existing aria-describedby value
 * @returns The error ID to use for aria-describedby, or the existing value if provided
 */
export function generateErrorId(
    componentPrefix: string,
    hasError: boolean,
    existingAriaDescribedBy?: string,
): string | undefined {
    if (hasError && !existingAriaDescribedBy) {
        return `${componentPrefix}-error-${Math.random().toString(36).substr(2, 9)}`;
    }
    return existingAriaDescribedBy;
}

/**
 * Generates a unique ID for any component element.
 *
 * @param prefix - The prefix to use for the ID
 * @returns A unique ID string
 */
export function generateUniqueId(prefix: string): string {
    return `${prefix}-${Math.random().toString(36).substr(2, 9)}`;
}
